import { Component, OnInit } from '@angular/core';
import Category from '../../data/category.json';
import Game from '../../data/gamesData.json';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit {
  public categorys = Category;
  public games = Game;
  catType: any;
  categoriesData: any;

  catOwl: OwlOptions = {
    items: 4,
    nav: false,
    dots: false,
    margin: 15,
    loop: true,
  };

  constructor(private _router: Router,
    private _activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.catType = this._activatedRoute.snapshot.paramMap.get('title');
    console.log('this.category', this.catType);
    this.getCategoryData(this.catType);
  }
  getCategoryData(catType) {
    let cat_filter = [catType]
    console.log('cat_filter', cat_filter);

    this.categoriesData = this.games.filter(function (item) {
      return cat_filter.indexOf(item.category) !== -1 && item.category === catType;
    });
    console.log("categoriesData", this.categoriesData);

  }
}
